import ModelFactory from 'business/models/ModelFactory';
import { GlobalDataVersionDTO, GlobalDataVersioningClient } from 'business/models/Models';

async function GetGDataVersion(): Promise<GlobalDataVersionDTO> {
  const globalDataVersioningClient: GlobalDataVersioningClient = ModelFactory(
    GlobalDataVersioningClient,
    false,
    true,
  );
  const appInfoData = await globalDataVersioningClient.getGlobalDataVersion();
  return appInfoData;
}

export { GetGDataVersion };
